import React from "react";
import Balancer from "react-wrap-balancer";
import { Container, Row, Col } from "react-bootstrap";
import pdfResume from "../../assets/2026_Bekky_Rage_Resume_online.pdf";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faBehance } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faFile } from '@fortawesome/free-solid-svg-icons'


export default function Hero() {
  return (

    <section id="hero" className="hero-section">
      <div className="hero-wrap">
        <Container>
          <Row>
            <div className="col-12 order-2 col-lg-6 order-lg-1 hero-col">
              <div className="hero-container">
                <div className="hero-content">
                    <p className="typing">Bekky Ragé. </p>
                    <h1 className="title">
                        <span className="accent-txt-primary">Full Stack</span>{ " " }
                        <br/>{ " " }
                        Web Developer{ " " }<br/>
                        <span className="plus">+</span>{ " " }

                        <span className="accent-txt-primary">Illustrative</span><br/>{ " " }
                        Graphic Designer{ " " }
                    </h1>

                  <div className="col-12 hero-contact">
                    <a href="https://linkedin.com/in/bekkyrage/" className="btn btn-primary" target="_blank">
                      <FontAwesomeIcon icon={faLinkedin} />LinkedIn
                    </a>
                    <a href="https://behance.net/bekkyrage" className="btn btn-primary" target="_blank">
                      <FontAwesomeIcon icon={faBehance} />Behance
                    </a>
                    <a href="mailto:bekkyrage@gmail.com" className="btn btn-primary" target="_blank">
                      <FontAwesomeIcon icon={faEnvelope} />Email
                    </a>
                    <a href={pdfResume} download="2026_Bekky_Rage_Resume_online.pdf" className="btn btn-primary">
                      <FontAwesomeIcon icon={faFile} />Resume
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 order-1 col-lg-6 order-lg-2">
              <div className="hero-img-wrap">
                <div className="hero-img">
                  <img src="./img/hero_img.png" alt="Hero Section" />
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </div>
    </section>
  );
}
